import React from 'react';
import { companyInfo } from '../data/mock';
import { Phone } from 'lucide-react';

const CTASection = () => {
  return (
    <section className="bg-black py-20 lg:py-28 relative">
      {/* Top gold line */}
      <div className="absolute top-0 left-0 right-0 gold-divider" />

      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <div className="animate-fade-in-up">
          {/* Decorative element */}
          <div className="flex justify-center mb-8">
            <div className="w-16 h-16 border-2 border-[#D4AF37] flex items-center justify-center">
              <Phone className="h-7 w-7 text-[#D4AF37]" />
            </div>
          </div>

          <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-white mb-8">
            ¿Tienes preguntas sobre tu trámite?
          </h2>

          <a
            href={companyInfo.telLink1}
            className="inline-flex items-center gap-3 btn-primary-custom px-10 py-5 text-lg font-semibold"
          >
            <Phone className="h-5 w-5" />
            No dudes en llamarnos
          </a>
        </div>
      </div>

      {/* Bottom gold line */}
      <div className="absolute bottom-0 left-0 right-0 gold-divider" />
    </section>
  );
};

export default CTASection;
